export default function SavoirFaire() {
  return (
    <section className="section section--alt">
      <div className="container">
        <div className="savoir-faire__content">
          <p className="section__label">Le constat</p>
          <h2 className="section__title">
            Vous avez un excellent savoir-faire.<br />
            Mais il vous manque une adresse digitale.
          </h2>
          <div style={{ marginTop: '24px' }}>
            <p>
              Aujourd'hui, le réflexe numéro un de vos clients, c'est Google.
              Et dans un monde où tout passe par internet, ne pas avoir de site
              web, c'est comme avoir votre boutique physique cachée au fond
              d'une impasse où personne ne passe.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
